import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wConsts from "../consts/website-consts";
import NotFound from "../components/notfound";
import SideBanners from "../components/sidebanners";
import * as wActs from "../actions/website-actions";
import SubHeader from "../components/subheader";
import LinkHeader from "../components/linkheader";
class Page404 extends Component {

  componentDidMount() {
    //this.props.pageHandler('home');
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "404" });
  }

  render() {
    //console.log("ccontent", this.props.Content)
    return (

      <div className={`main`}>
        <SubHeader/>
        <div className="container">
          <LinkHeader/>
          <div className="content flex flex--between">
            <SideBanners isLeft={true}/>
            <div className="content" style={{paddingTop: "50px"}}>
              <NotFound/>
            </div>
            <SideBanners isLeft={false}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Content: state.Website.Page.Content
  };
}

export default connect(mapStateToProps)(Page404);
